export default [
  { art: "17410", beschreibung: "Apotheke" },
  { art: "15050", beschreibung: "Arztpraxis" },
  { art: "15310", beschreibung: "Büro" },
  { art: "16080", beschreibung: "Café" },
  { art: "15010", beschreibung: "Friseur" },
  { art: "16030", beschreibung: "Gaststätte" },
  { art: "17040", beschreibung: "Getränkehandel" },
  { art: "15050", beschreibung: "Heilpraxis" },
  { art: "16040", beschreibung: "Imbiss" },
  { art: "15310", beschreibung: "Kanzlei" },
  { art: "16040", beschreibung: "Kiosk" },
  { art: "15090", beschreibung: "Körperpflegebetrieb" },
  { art: "15090", beschreibung: "Kosmetiksalon" },
  { art: "17010", beschreibung: "Lebensmittelhandel" },
  { art: "16030", beschreibung: "Restaurant" },
];
